import { ButtonVariantProps } from "../../../components/button/ButtonVariant"

export const normal: ButtonVariantProps = {
  boxClassName: "px-3 py-2",
  textClassName: "text-base leading-6 font-medium",
}
